// @flow
import * as React from 'react';

type Args = {
  direction: 'horizontal' | 'vertical',
  initialSize: number | string,
};

export const useResizable = ({direction, initialSize}: Args) => {
  const [resizedLength, setResizedLength] = React.useState<number | string>(
    initialSize,
  );
  const [isDragging, setIsDragging] = React.useState(false);

  const handleMouseDown = () => {
    const handleDrag = (e: MouseEvent) => {
      setIsDragging(true);

      if (direction === 'vertical') {
        setResizedLength(() => Math.abs(e.clientY - window.innerHeight));
      } else {
        setResizedLength(() => e.clientX);
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);

      document.removeEventListener('mousemove', handleDrag);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return {resizedLength, isDragging, handleMouseDown};
};
